import React from "react";
import "../Actividad.css";

function ActividadInfoForm({ actividad }) {
  if (!actividad) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="actividad-info">
      <h5>Coordinación</h5>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Jefe/a Proyecto:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.jefe && actividad.jefe.nombre
            ? actividad.jefe.nombre
            : "-----"}
        </div>
      </div>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Coordinador/a:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.coordinador && actividad.coordinador.nombre
            ? actividad.coordinador.nombre
            : "-----"}
        </div>
      </div>

      <h5>Empresas</h5>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Empresas:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.empresa && actividad.empresa.length > 0
            ? actividad.empresa.map((empresa, index) => (
                <span key={empresa.id}>
                  {empresa.nombre}
                  {index < actividad.empresa.length - 1 ? ", " : ""}
                </span>
              ))
            : "-----"}
        </div>
      </div>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Otecs:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.otec && actividad.otec.length > 0
            ? actividad.otec.map((otec, index) => (
                <span key={otec.id}>
                  {otec.nombre}
                  {index < actividad.otec.length - 1 ? ", " : ""}
                </span>
              ))
            : "-----"}
        </div>
      </div>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Asociados:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.asociado && actividad.asociado.length > 0
            ? actividad.asociado.map((asociado, index) => (
                <span key={asociado.id}>
                  {asociado.nombre}
                  {index < actividad.asociado.length - 1 ? ", " : ""}
                </span>
              ))
            : "-----"}
        </div>
      </div>
    </div>
  );
}

export default ActividadInfoForm;
